<template>
  <header class="HtmlHeader">
    <!-- 更新后的Logo区域 -->
    <div class="logo">
      <div class="logo-icon">C</div>
      <div class="logo-text">cxxdgc</div>
    </div>

    <!-- 导航菜单（桌面端） -->
    <div @command="handleCommand" class="right-group">
      <nav class="nav-desktop">
        <ul class="nav-list">
          <li v-for="(item, index) in navItems" :key="index" class="nav-item">
            <router-link 
              :to="item.path" 
              class="nav-link" 
              active-class="active"
              exact-active-class="active"
              @click="handleNavClick(item)">
              {{ item.title }}
            </router-link>
          </li>
        </ul>
      </nav>
    </div>

    <!-- 移动端菜单切换按钮 -->
    <button class="menu-toggle" @click="toggleMobileMenu" aria-label="切换导航菜单">
      <span class="hamburger"></span>
    </button>

    <!-- 移动端导航菜单 -->
    <Transition name="slide-down">
      <nav v-show="isMobileMenuOpen" class="nav-mobile">
        <ul class="nav-list-mobile">
          <li v-for="(item, index) in navItems" :key="index" class="nav-item-mobile">
            <router-link 
              :to="item.path" 
              class="nav-link-mobile" 
              active-class="active"
              exact-active-class="active"
              @click="toggleMobileMenu">
              {{ item.title }}
            </router-link>
          </li>
        </ul>
      </nav>
    </Transition>
  </header>
</template>

<script setup>
import { ref } from 'vue';
import { useRouter } from 'vue-router';

const router = useRouter()

const navItems = ref([
  { title: '首页', path: '/', exact: true },
  { title: '项目', path: '/Project/', exact: true },
  { title: '课程', path: '/Course', exact: true },
  { title: '严小希', path: '/Yanxx_Introduction', exact: true },
])


const isMobileMenuOpen = ref(false)

const toggleMobileMenu = () => {
  isMobileMenuOpen.value = !isMobileMenuOpen.value
}

const handleNavClick = (item) => {
  router.push(item.path)
  isMobileMenuOpen.value = false
}
</script>

<style scoped>
:root {
  --primary: #FF9800;
  --primary-dark: #F57C00;
  --secondary: #37474F;
  --light: #f9f9f9;
  --gray: #78909C;
  --dark: #263238;
  --card-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  --transition: all 0.3s cubic-bezier(0.25, 0.8, 0.25, 1);
}

.HtmlHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 30px 20px;
  border-bottom: 2px solid rgba(255, 152, 0, 0.2);
  position: relative;
  background-color: transparent;
  box-shadow: none;
}

.logo {
  display: flex;
  align-items: center;
  gap: 15px;
}

.logo-icon {
  background: var(--primary);
  width: 50px;
  height: 50px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
  font-size: 24px;
  font-weight: bold;
  box-shadow: 0 4px 10px rgba(255, 152, 0, 0.3);
}

.logo-text {
  font-size: 28px;
  font-weight: 700;
  background: linear-gradient(45deg, var(--primary-dark), var(--primary));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.nav-list {
  display: flex;
  gap: 10px;
  list-style: none;
}

.nav-link {
  color: var(--secondary);
  text-decoration: none;
  font-weight: 500;
  font-size: 18px;
  padding: 8px 15px;
  border-radius: 50px;
  transition: var(--transition);
}

.nav-link:hover,
.nav-link.active {
  background: var(--primary);
  color: white;
}

.right-group {
  display: flex;
  align-items: center;
}

/* 移动端导航菜单 */
.nav-mobile {
  position: absolute;
  top: 100%;
  left: 0;
  right: 0;
  background: white;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.1);
  z-index: 100;
}

.nav-list-mobile {
  list-style: none;
  padding: 10px 0;
}

.nav-item-mobile {
  padding: 12px 20px;
}

.nav-link-mobile {
  display: block;
  color: var(--secondary);
  text-decoration: none;
  font-size: 18px;
  padding: 8px 15px;
  border-radius: 50px;
  transition: var(--transition);
}

.nav-link-mobile:hover,
.nav-link-mobile.active {
  background: rgba(255, 152, 0, 0.2);
  color: var(--primary-dark);
}

/* 汉堡菜单样式 */
.menu-toggle {
  display: block;
  background: none;
  border: none;
  padding: 0.5rem;
  cursor: pointer;
  z-index: 1000;
}

.hamburger {
  display: block;
  width: 28px;
  height: 3px;
  background: var(--secondary);
  position: relative;
  transition: var(--transition);
}

.hamburger::before,
.hamburger::after {
  content: '';
  position: absolute;
  width: 100%;
  height: 100%;
  background: inherit;
  transition: var(--transition);
}

.hamburger::before {
  transform: translateY(-8px);
}

.hamburger::after {
  transform: translateY(8px);
}

/* 添加激活状态下的汉堡菜单动画 */
.menu-toggle[aria-expanded="true"] .hamburger {
  background: transparent;
}

.menu-toggle[aria-expanded="true"] .hamburger::before {
  transform: rotate(45deg);
}

.menu-toggle[aria-expanded="true"] .hamburger::after {
  transform: rotate(-45deg);
}

/* 过渡动画 */
.slide-down-enter-active,
.slide-down-leave-active {
  transition: all 0.4s ease;
}

.slide-down-enter-from,
.slide-down-leave-to {
  opacity: 0;
  transform: translateY(-20px);
}

/* 响应式设计 */
@media (min-width: 768px) {
  .nav-desktop {
    display: block;
  }

  .menu-toggle {
    display: none;
  }

  .nav-mobile {
    display: none;
  }
}

@media (max-width: 767px) {
  .HtmlHeader {
    padding: 20px 15px;
  }
  
  .nav-desktop {
    display: none;
  }
  
  .logo-text {
    font-size: 22px;
  }
  
  .logo-icon {
    width: 40px;
    height: 40px;
    font-size: 20px;
  }
}
</style>
